/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { MockResourceReduced } from "./MockResourceReduced";
import * as t from "io-ts";

/**
 * The paginated list of mock resources.
 */

// required attributes
const MockResourceListR = t.interface({
  page_info: PageInfo,

  resources: t.readonlyArray(
    MockResourceReduced,
    "array of MockResourceReduced"
  )
});

// optional attributes
const MockResourceListO = t.partial({});

export const MockResourceList = t.intersection(
  [MockResourceListR, MockResourceListO],
  "MockResourceList"
);

export type MockResourceList = t.TypeOf<typeof MockResourceList>;
